import { EcommerceConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root"

export const useEcommerceConfig = () => {
  const { config } = useRootLoaderData();
  return config.Ecommerce as EcommerceConfigSection;
};
